import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MainService } from 'src/app/services/main.service';
import { UtilsService } from 'src/app/services/utils.service';
import { ModalAddTradeAgreementComponent } from '../modal-add-trade-agreement/modal-add-trade-agreement.component';
import { ModalMessageComponent } from '../modal-message/modal-message.component';

@Component({
  selector: 'app-modal-view-product',
  templateUrl: './modal-view-product.component.html',
  styleUrls: ['./modal-view-product.component.scss']
})
export class ModalViewProductComponent implements OnInit {

  businessUnitNames: any = [];
  productLines: any = [];
  totalcode: any = [];
  chargeTypes: any = [];
  providers: any = [];
  providersGenerated: any = [
    // { control_provider: 'provider_1', control_cost: 'product_cost_1', control_base: 'base_price_prov_1', control_type: 'type_pay_prov_1' }
    { control_provider: 'provider_1', control_base: 'base_price_prov_1', control_type: 'type_pay_prov_1' }
  ];

  productForm: FormGroup = new FormGroup({
    business_unit_id: new FormControl(''),
    business_unit_code: new FormControl('---'),
    product_line_id: new FormControl(''),
    product_line_code: new FormControl('---'),
    name: new FormControl(''),
    charge_type_id: new FormControl(''),
    internal_code: new FormControl(''),
    total_code: new FormControl('-----------'),
    currency_id: new FormControl('1'),
    base_price: new FormControl(''),
    // provider_id: new FormControl(''),
    // product_cost: new FormControl(''),
    type_pay: new FormControl(''),
    provider_1: new FormControl('', Validators.required),
    // product_cost_1: new FormControl('', Validators.required),
    base_price_prov_1: new FormControl('', Validators.required),
    type_pay_prov_1: new FormControl('flat_fee', Validators.required),
  });

  getBusinessUnitNames(){
    this.mService.get_request('business-unit/list')
    .subscribe((resp: any)=>{
      if( resp.status ){
        this.businessUnitNames = resp.items;
      }else{
        this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
        if(resp.message.includes('expirado')){
          this.uService.logOut$.next(true);
        }
      }
    });
  };

  getProductLines(){
    this.mService.get_request('product-line/list')
    .subscribe((resp: any)=>{
      if( resp.status ){
        this.productLines = resp.items;
      }else{
        this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
        if(resp.message.includes('expirado')){
          this.uService.logOut$.next(true);
        }
      }
    });
  };

  getChargeTypes(){
    this.mService.get_request('charge-type/list')
    .subscribe((resp:any) =>{
      if(resp.status){
        this.chargeTypes = resp.items;
      }else{
        this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
        if(resp.message.includes('expirado')){
          this.uService.logOut$.next(true);
        }
      }
    })
  }

  getProductLineCode(id){
    var body: any = {
      id: id
    }
    this.mService.get_request('product-line/list', body)
    .subscribe((resp:any) =>{
      if(resp.status){
        this.totalcode[1] = resp.items[0].code;
        this.productForm.get('total_code').setValue(`${this.totalcode[0] || '---'}-${this.totalcode[1] || '---'}-${this.totalcode[2] || '---'}`);
        this.productForm.get('product_line_code').setValue(resp.items[0].code);
      }else{
        this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
        if(resp.message.includes('expirado')){
          this.uService.logOut$.next(true);
        }
      }
    })
  }

  getBusinessUnitCode(id){
    var body: any = {
      id: id
    }
    this.mService.get_request('business-unit/list', body)
    .subscribe((resp:any) =>{
      if(resp.status){
        this.totalcode[0] = resp.items[0].code;
        this.productForm.get('total_code').setValue(`${this.totalcode[0] || '---'}-${this.totalcode[1] || '---'}-${this.totalcode[2] || '---'}`);
        this.productForm.get('business_unit_code').setValue(resp.items[0].code);
      }else{
        this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
        if(resp.message.includes('expirado')){
          this.uService.logOut$.next(true);
        }
      }
    })
  }

  setTotalCode(){
    var value = this.productForm.get('internal_code').value;
    this.totalcode[2] = value;
    this.productForm.get('total_code').setValue(`${this.totalcode[0] || '---'}-${this.totalcode[1] || '---'}-${this.totalcode[2] || '---'}`);
  }

  getProviders(){
    this.mService.get_request('provider/list')
    .subscribe((resp: any)=>{
      if(resp.status){

        this.providers = resp.items;
      }else{
        this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
        if(resp.message.includes('expirado')){
          this.uService.logOut$.next(true);
        }
      }
    });
  };

  constructor(
    private uService: UtilsService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ModalViewProductComponent>,
    private mService: MainService, private toast: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ){
    this.getBusinessUnitNames();
    this.getProductLines();
    this.getChargeTypes();
    this.getProviders();

    console.log(this.data, 'data');


    this.productForm.get('business_unit_id').setValue(this.data.business_unit_id);
    this.productForm.get('product_line_id').setValue(this.data.product_line_id);
    this.productForm.get('name').setValue(this.data.name);
    this.productForm.get('charge_type_id').setValue(this.data.charge_type_id);
    this.productForm.get('internal_code').setValue(this.data.internal_code);
    // this.productForm.get('total_code').setValue(this.data.total_code);
    this.getBusinessUnitCode(this.data.business_unit_id);
    this.getProductLineCode(this.data.product_line_id);
    this.setTotalCode();
    this.productForm.get('base_price').setValue(this.data.base_price);
    // this.productForm.get('provider_id').setValue(this.data.provider_ids);
    // this.productForm.get('product_cost').setValue(this.data.product_cost);
    this.productForm.get('type_pay').setValue(this.data.type_pay);

    if(this.data.product_provider != undefined){
      for (let index = 1; index <= this.data.product_provider.length; index++) {
        var ctrl_provider = `provider_${index}`;
        // var ctrl_cost = `product_cost_${index}`;
        var ctrl_base_price_prov = `base_price_prov_${index}`;
        var ctrl_type_pay_prov = `type_pay_prov_${index}`;

        if (index != 1) {
          this.productForm.addControl(ctrl_provider, new FormControl('', Validators.required));
          // this.productForm.addControl(ctrl_cost ,new FormControl('', Validators.required));
          this.productForm.addControl(ctrl_base_price_prov ,new FormControl('', Validators.required));
          this.productForm.addControl(ctrl_type_pay_prov ,new FormControl('flat_fee', Validators.required));

          this.providersGenerated.push(
            // { control_provider: ctrl_provider, control_cost: ctrl_cost, control_base: ctrl_base_price_prov, control_type: ctrl_type_pay_prov }
            { control_provider: ctrl_provider, control_base: ctrl_base_price_prov, control_type: ctrl_type_pay_prov }
          );
        }

        this.productForm.get(ctrl_provider).setValue(this.data.product_provider[index - 1].provider_id)
        // this.productForm.get(ctrl_cost).setValue(this.data.product_provider[index - 1].product_cost)
        this.productForm.get(ctrl_base_price_prov).setValue(this.data.product_provider[index - 1].base_price)
        this.productForm.get(ctrl_type_pay_prov).setValue(this.data.product_provider[index - 1].type_pay)
      }
    }
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
  }

  dismiss(data?) {
    this.dialogRef.close( null );
  }
}

